export interface IMeetingItem {
  account_firstname: string;
  account_id: number;
  account_lastname: string;
  contact_company: string;
  contact_email: string;
  contact_firstname: string;
  contact_id: number;
  contact_lastname: string;
  campaign_name: string;
  meeting_id: number;
  meeting_date: string;
  pipeline_state: string;
  meeting_state: number;
  won_lost_date: string;
  lost_reason_code: string;
  contract_value: string;
}

export enum EMeetingActions {
  VIEW_MEETING = '[Meeting] View Meeting',
  REFRESH_MEETING = '[Meeting] REFRESH Meeting',
  VIEW_MEETING_SUCCESS = '[Meeting] View Meeting Success',
  VIEW_MEETING_ERROR = '[Meeting] View Meeting Error',
  UPDATE_MEETING = '[Meeting] Update Meeting',
  UPDATE_MEETING_SUCCESS = '[Meeting] Update Meeting Success',
  UPDATE_MEETING_ERROR = '[Meeting] Update Meeting Error',
  DELETE_MEETING = '[Meeting] Delete Meeting',
  DELETE_MEETING_SUCCESS = '[Meeting] Delete Meeting Success',
  DELETE_MEETING_ERROR = '[Meeting] Delete Meeting Error',
  RESTORE_MEETING = '[Meeting] Restore Meeting',
  RESTORE_MEETING_SUCCESS = '[Meeting] Restore Meeting Success',
  RESTORE_MEETING_ERROR = '[Meeting] Restore Meeting Error',
  ADD_A_PRODUCT = '[Associated product] Add product',
  ADD_A_PRODUCT_SUCCESS = '[Associated product] Add product Success',
  ADD_A_PRODUCT_ERROR = '[Associated product] Add product Error',
  UPDATE_A_PRODUCT = '[Associated product] Update product',
  UPDATE_A_PRODUCT_SUCCESS = '[Associated product] Update product Success',
  UPDATE_A_PRODUCT_ERROR = '[Associated product] Update product Error',
  DELETE_A_PRODUCT = '[Associated product] Delete product',
  DELETE_A_PRODUCT_SUCCESS = '[Associated product] Delete product Success',
  DELETE_A_PRODUCT_ERROR = '[Associated product] Delete product Error',
  UPDTATE_LEFT_MENU_COUNT = '[LEFT MENU] Update Count',
  UPDTATE_LEFT_MENU_COUNT_SUCCESS = '[LEFT MENU] Update Count Success',
  UPDTATE_LEFT_MENU_COUNT_ERROR = '[LEFT MENU] Update Count Error',
}

export interface IMeetingState {
  status: EMeetingStateStatus;
  state: any;
  data: IMeeting[];
  ids?: number[];
  current_messages?: IMeeting[];
  current_message_id?: number;
  next_message_id?: number;
  prev_message_id?: number;
  error?: any;
  has_extra_row?: boolean;
  locked_by?: number;
}

export enum EMeetingStateStatus {
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  READY = 'ready',
  READY_S = 'ready secondary',
  UPDATING = 'updating',
  UPDATED = 'updated',
  DELETED = 'deleted',
  ADDED_PROD = 'added product',
  UPDATED_PROD = 'updated product',
  DELETED_PROD = 'deleted product',
  ERROR = 'error',
}

export enum EMeetingStatus {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

export interface IMeeting {
  meeting_id: number;
  meeting_date?: string;
  meeting_time?: string;
  meeting_note?: string;
}
